import { Link } from "react-router-dom";
import { ArrowRight, Ghost, Gift } from "lucide-react";
import { getSeason } from "@/data/season";

export default function SeasonBanner() {
  const season = getSeason();
  if (!season) return null;
  const Icon = season.id === "halloween" ? Ghost : Gift;
  return (
    <Link
      to={season.path}
      data-testid="season-banner"
      className="block bg-espresso px-4 py-2.5 text-center transition-colors duration-300 hover:bg-[#2A1810]"
    >
      <span className="inline-flex flex-wrap items-center justify-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-cream sm:text-xs">
        <Icon size={14} strokeWidth={1.5} className="text-terracotta" />
        {season.banner} — le {season.menuName} livré à domicile
        <ArrowRight size={13} strokeWidth={2} className="text-terracotta" />
      </span>
    </Link>
  );
}
